import {Track} from "./track";

export class PlayData {
  constructor(
    public tracks: Track[],
    public trackNum: number
  ) {}
}
